import TNTBillingBase from "../../util/TNTBillingBase";

class ContractController extends TNTBillingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'contract'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_billing_contract']) {
      this.hasACL[this.acl['tnt_billing_contract'][key]] = true;
    }
  }
}

export default ContractController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/contract.controller.js